<template>
<main-content>
    <div v-for="(item, index) in newslist" :key="index">
        <div class="bg-white rounded shadow-sm my-3">
            <div class="d-flex align-items-center justify-content-between p-3">
                <div class="h5 mb-0" v-text="item.subject"></div>
                <div>
                    <i class="fa fa-clock"></i>
                    {{item.created_at}}
                </div>
            </div>
            <hr class="my-2 custom_hr">
            <div class="p-3" v-html="item.newscontent"></div>
        </div>
    </div>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content';
import { mapState, mapActions } from "vuex";

export default {
    components: {
        mainContent
    },
    mounted() {
        this.getnews();
    },
    computed: {
        ...mapState("news", [
            "newslist",
        ]),
    },
    watch: {
        newslist(value) {
            window.localStorage.setItem('news_old_count', parseInt(value.length));
            window.localStorage.setItem('news_new_count', parseInt(value.length));
        },
    },
    methods: {
        ...mapActions("news", [
            "getnews",
        ]),
    },
}
</script>
